export const getProjectLink = <T extends { id: string; title: string }>(project: T) => {
	return `/projects/${project.id}/${project.title.replace(/\s+/g, '-').toLowerCase()}`;
};
